export default __webpack_public_path__ + "static/icons8-internet-50.apng-0f87e8d0e9f165cdb0bd41806122b38a.png";